import React from "react";
import PanelGroupController from "../../../components/PanelGroupController";
import {fromJS, List} from "immutable";
import PropertiesList from "../../../components/panels/PropertiesList";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {Query} from "react-apollo";
import {WATER_CONTAINER} from "../../../queries/inventory";

// Where the container is, in words. A location only counts as known once a
// tracked stock transfer delivered it; before that it is just where the
// container was registered.
function describeLocation(custody) {
  if (!custody) return "";
  const type = custody.get("locationType");
  const id = custody.get("locationId");
  if (type === "in_transit") return `In transit (transfer ${id})`;
  if (type === "client") return `Dispatched to client ${id}`;
  if (custody.get("locationConfirmed")) return id;
  return `${id} (where it was registered; not tracked since)`;
}

function describeMovement(movement) {
  const to = movement.get("toType") === "in_transit" ? "in transit" : movement.get("toId");
  switch (movement.get("event")) {
    case "registered": return `Registered at ${to}`;
    case "dispatched": return `Dispatched from ${movement.get("fromId")}`;
    case "received": return `Received at ${to}`;
    case "returned": return `Returned to ${to}`;
    default: return `${movement.get("event")} → ${to}`;
  }
}

const MovementHistory = ({movements}) => {
  if (!movements || movements.size === 0) return null;
  return (
    <table className="ContainerMovements">
      <thead>
        <tr><th>When</th><th>What</th><th>Transfer</th></tr>
      </thead>
      <tbody>
        {movements.map((movement, i) => (
          <tr key={i}>
            <td>{String(movement.get("occurredAt") || "").substr(0, 16).replace("T", " ")}</td>
            <td>{describeMovement(movement)}</td>
            <td>{movement.get("documentId")}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

const WaterContainerPropertiesPanel = (props) => {

  let elements = null;
  if (!props.selectedId) {
    elements = <p className="u-no-selection">Nothing selected</p>
  } else {
    let items = fromJS([
      {prop: "serial", label: "Serial Nr.", type: "id"},
      {prop: "palletId", label: "Pallet id", type: "string"},
      {prop: "state", label: "State", type: "string"},
      {prop: "sku", label: "SKU", type: "string"},
      {prop: "createdAt", label: "Recorded", type: "utc"},
      {prop: "location", label: "Location", type: "string"},
      {prop: "onTransfer", label: "On Transfer", type: "string"}
    ])
    //
    let testResults = fromJS([
      {prop: "testCategory", label: "Test Results", type: "category"},
      {prop: "testResult", label: "Result", type: "string"},
      {prop: "testLabName", label: "Lab", type: "string"},
      {prop: "testNr", label: "Test nr.", type: "string"}
      // {prop: "test_recorded_at", label: "Recorded", type: "utc"}
    ])    
    let variables = {serial: props.selectedId}
    elements = (
      <Query query={WATER_CONTAINER} variables={variables} skip={!props.selectedId}>
        {({ loading, error, data }) => {
          if (loading) return <Loading />
          if (error) return <GraphQLErrors error={error} />
          let container = fromJS(data.waterContainer);
          let custody = container.get("custody");
          container = container
            .set("location", describeLocation(custody))
            .set("onTransfer", custody ? custody.get("documentId") : "");
          let properties = (container.get("testResult") === "pending") ? items : items.concat(testResults);
          return (
            <React.Fragment>
              <PropertiesList properties={properties} data={container} />
              <MovementHistory movements={container.get("movements", List())} />
            </React.Fragment>
          )
        }}
      </Query>
    )
  }

  return (
    <PanelGroupController title="Water Container" expanded={props.expanded}>
      {elements}
    </PanelGroupController>
  )

}

export default WaterContainerPropertiesPanel;